<h2 mat-dialog-title>{{ isEditMode ? 'Edit MIPS Submission Block' : 'Block MIPS Submission' }}</h2>

<mat-dialog-content>
  <div class="org-label">Organization: <strong>{{ data.organizationName }}</strong></div>

  <div class="reason-label">Reason*</div>
  <div class="reason-list">
    @for (reason of reasons; track reason.code) {
      <mat-checkbox
        [checked]="isSelected(reason.code)"
        (change)="toggleReason(reason.code, $event.checked)"
        class="reason-option"
      >
        <div class="reason-name">{{ reason.name }}</div>
        <div class="reason-description">{{ reason.description }}</div>
      </mat-checkbox>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-button
    color="primary"
    (click)="onSave()"
    [disabled]="selectedReasonCodes.length === 0 || (saving$ | async)"
  >
    Save
  </button>
  <button mat-button (click)="onClose()">Close</button>
</mat-dialog-actions>
